import { toasts as toastActions } from '../actions';
import { profileReducer } from '../reducers';

export const muteToastMiddleWare = (store) => next => action => {
  const nextAction = { ...action };
  const state = store.getState();
  const profileOptions = profileReducer.getUserConfiguration(state);

  // intercepts an ADD_TOASTR by react-redux-toastr and converts to an ADD_MUTED_TOAST
  // action if profile options detect muting option activated.  This will still place
  // the toast into the recent dropdown list in the UI, but will not show pop-up
  if (action.type === toastActions.ADD_TOAST && profileOptions.muteToasts) {
    nextAction.type = toastActions.ADD_MUTED_TOAST;
  }

  next(nextAction);
};


// WEBPACK FOOTER //
// src/middleware/muteToasts.js